import React from 'react';
import "../../../styles/PartnerDetailPage.css";
import '../../../styles/ProductDetailPageCpa.css';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import ReactHtmlParser from "react-html-parser";
import transform from '../../../transform/index';
import Body from './Body';
import Footer from '../../FooterComponent/Footer';
import ErrorHomePage from '../../../components/ErrorPageComponent/ErrorHomePage';
import {digital} from '../../../DigitalData.js';
import { doGetCall } from '../../../config/rest';

class PartnerDetailPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {partnerResponse: null, partnerBannerData: null};
  }
  getProductLevelData = () => {
    doGetCall(`/wp-json/hybris/v1/partners/${global.partnerId}/exams`)
    .then(res => {this.setState({partnerResponse: res, error: null})})
    .catch(err => {this.setState({error: err})})
    doGetCall(`/wp-json/wp/v2/pages?slug=partner-banner`)
    .then(res => {this.setState({partnerBannerResponse: res[0], partnerBannerData: res[0].acf, error: null})})
    .catch(err => {this.setState({error: err})})
  }
  componentDidMount() {
    digital();
    window.scrollTo(0, 0);
    global.partnerId = this.props.match.params.partnerId;
    this.getProductLevelData();
  }
  componentDidUpdate() {
    digital();
  }
  
  render() {
    const { footerData } = this.props;
    if(this.state.error) {
      return <ErrorHomePage {...this.props}/>
    } else {
      return (
        <div>
          {this.state.partnerBannerResponse && (
          <Helmet>
            {ReactHtmlParser(this.state.partnerBannerResponse.yoast_head, transform.options)}
            <meta className="swiftype" name="page_type" data-type="enum" content="Other" />
          </Helmet>
          )}

          {this.props && this.state.partnerBannerData && this.state.partnerResponse
            && <Body {...this.props} PartnerDetailPageResponse={this.state.partnerResponse}
            PartnerDetailBannerComponents={this.state.partnerBannerData.components}
            backgroundImages={this.state.partnerBannerData.background_images} />}
  
          {this.state.partnerBannerData && this.state.partnerResponse &&
          <Footer leftColData={footerData.footer !== undefined && footerData.footer['footer-left-menu']}
          showSocialIcons showFooterNote />}
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  footerData: state.HeaderFooterData.items
});
export default connect(mapStateToProps)(PartnerDetailPage);
